/**
 * Program sessions (client side) — one doc per completed program day.
 * Created when the client taps "Finish day" in ProgramViewPage.
 */
import { collection, addDoc, getDocs, query, where, orderBy, limit, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'programSessions';

export function programSessionRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();
  const coll = () => collection(firestore, COLLECTION);

  return {
    async create(data) {
      const ref = await addDoc(coll(), {
        ...data,
        completedAt: serverTimestamp(),
      });
      return ref.id;
    },

    async listByClientProgram(clientId, programId, limitCount = 200) {
      const q = query(
        coll(),
        where('clientId', '==', clientId),
        where('programId', '==', programId),
        orderBy('completedAt', 'desc'),
        limit(limitCount)
      );
      const snap = await getDocs(q);
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    },
  };
}

export const programSessionRepo = programSessionRepository();
